import { render, staticRenderFns } from "./memberData.vue?vue&type=template&id=e5ff06ce&scoped=true&"
import script from "./memberData.vue?vue&type=script&lang=js&"
export * from "./memberData.vue?vue&type=script&lang=js&"
import style0 from "./memberData.vue?vue&type=style&index=0&id=e5ff06ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ff06ce",
  null
  
)

export default component.exports